import React, { Component } from "react";
import { Helmet } from "react-helmet";
// import _ from "lodash";
import { Route, Switch, Link } from "react-router-dom";
import { UserContext } from "../../Context";
import AdminApps from "./AdminApps";

import Loading from "../../components/loading/Loading";
import LoggedOutContent from "../../components/LoggedOutContent/LoggedOutContent";

import Button from "@atlaskit/button";
import AdminListings from "./AdminListings";
import AdminUsers from "./AdminUsers";
import AdminCreate from "./AdminCreate";
import User from "../user/User";

export default class Admin extends Component {
  render() {
    return (
      <UserContext.Consumer>
        {userContext => {
          return (
            <div className="admin">
              <Helmet>
                <title>{`Admin `}</title>
              </Helmet>
              {userContext.userLoading && (
                <div className="admin-loading full-body-content">
                  <Loading />
                </div>
              )}
              {!userContext.userLoading &&
                !userContext.user && (
                  <div className="admin__login">
                    <LoggedOutContent />
                  </div>
                )}
              {!userContext.userLoading &&
                userContext.custom &&
                !!userContext.custom.admin && (
                  <Switch>
                    <Route
                      exact
                      path="/admin"
                      render={props => (
                        <div>
                          <Link
                            className="admin__nav-link-btn"
                            to={`/admin/apps`}
                          >
                            <Button shouldFitContainer>Applications</Button>
                          </Link>
                          <Link
                            className="admin__nav-link-btn"
                            to={`/admin/users`}
                          >
                            <Button shouldFitContainer>Users</Button>
                          </Link>
                          <Link
                            className="admin__nav-link-btn"
                            to={`/admin/listings`}
                          >
                            <Button shouldFitContainer>Listings</Button>
                          </Link>
                          <Link
                            className="admin__nav-link-btn"
                            to={`/admin/create`}
                          >
                            <Button shouldFitContainer>Create</Button>
                          </Link>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/admin/apps"
                      render={() => (
                        <div className="admin-container">
                          <Helmet>
                            <title>{`Admin Applications`}</title>
                          </Helmet>
                          <div className="admin-body">
                            <AdminApps />
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/admin/users"
                      render={() => (
                        <div className="admin-container">
                          <Helmet>
                            <title>{`Admin Applications`}</title>
                          </Helmet>
                          <div className="admin-body">
                            <AdminUsers />
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/admin/listings"
                      render={() => (
                        <div className="admin-container">
                          <Helmet>
                            <title>{`Admin Listings`}</title>
                          </Helmet>
                          <div className="admin-body">
                            <AdminListings />
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/admin/create"
                      render={props => (
                        <div className="admin-container">
                          <Helmet>
                            <title>{`Admin Create`}</title>
                          </Helmet>
                          <div className="admin-body">
                            <AdminCreate
                              addFlag={userContext.addFlag}
                              {...props}
                            />
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      exact
                      path="/admin/user"
                      render={props => (
                        <div className="admin-container">
                          <Helmet>
                            <title>{`Admin User`}</title>
                          </Helmet>
                          <div className="admin-body">
                            <User addFlag={userContext.addFlag} {...props} />
                          </div>
                        </div>
                      )}
                    />
                  </Switch>
                )}
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin/Admin.js